import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { FormInput, FormSelect } from 'view/components/Form';

const SmsOutboundFilters = ({
	filters,
	filterOptions,
	onFilterChange,
	onSearch,
	onReset,
}) => {
	const { control, handleSubmit, reset } = useForm({
		defaultValues: {
			search: filters.search || '',
			status: filters.status || 'all',
			tier: filters.tier || 'all',
			template_key: filters.template_key || 'all',
			date_from: filters.date_from || '',
			date_to: filters.date_to || '',
		},
		mode: 'onChange',
	});

	useEffect(() => {
		reset({
			search: filters.search || '',
			status: filters.status || 'all',
			tier: filters.tier || 'all',
			template_key: filters.template_key || 'all',
			date_from: filters.date_from || '',
			date_to: filters.date_to || '',
		});
	}, [filters, reset]);

	const onSubmitForm = (data) => {
		onSearch(data);
	};

	const handleReset = () => {
		reset({
			search: '',
			status: 'all',
			tier: 'all',
			template_key: 'all',
			date_from: '',
			date_to: '',
		});
		onReset();
	};

	const statusOptions = filterOptions?.statuses?.length
		? filterOptions.statuses
		: [
				{ value: 'all', label: 'All Statuses' },
				{ value: 'pending', label: 'Pending' },
				{ value: 'sent', label: 'Sent' },
				{ value: 'sent_digest', label: 'Sent (Digest)' },
				{ value: 'failed', label: 'Failed' },
		  ];

	const tierOptions = filterOptions?.tiers?.length
		? filterOptions.tiers
		: [
				{ value: 'all', label: 'All Tiers' },
				{ value: 'urgent', label: 'Urgent' },
				{ value: 'standard', label: 'Standard' },
		  ];

	const templateOptions = filterOptions?.templates?.length
		? filterOptions.templates
		: [{ value: 'all', label: 'All Templates' }];

	return (
		<div className="card mb-4">
			<div className="card-header">
				<h6 className="mb-0">
					<i className="bi bi-funnel me-2" />
					Outbound Filters
				</h6>
			</div>
			<div className="card-body">
				<form onSubmit={handleSubmit(onSubmitForm)}>
					<div className="row g-3">
						<div className="col-md-3">
							<FormInput
								name="search"
								control={control}
								label="Search"
								placeholder="Phone, user, address, SID..."
								helpText="Search recipient, property, or SID"
							/>
						</div>
						<div className="col-md-2">
							<FormSelect
								name="status"
								control={control}
								label="Status"
								options={statusOptions}
								placeholder={null}
							/>
						</div>
						<div className="col-md-2">
							<FormSelect
								name="tier"
								control={control}
								label="Tier"
								options={tierOptions}
								placeholder={null}
							/>
						</div>
						<div className="col-md-3">
							<FormSelect
								name="template_key"
								control={control}
								label="Template"
								options={templateOptions}
								placeholder={null}
							/>
						</div>
						<div className="col-md-2">
							<FormInput
								name="date_from"
								control={control}
								type="date"
								label="Date From"
							/>
						</div>
						<div className="col-md-2">
							<FormInput
								name="date_to"
								control={control}
								type="date"
								label="Date To"
							/>
						</div>
					</div>
					<div className="d-flex gap-2 mt-3">
						<button type="submit" className="btn btn-primary">
							<i className="bi bi-search me-2" />
							Search
						</button>
						<button
							type="button"
							className="btn btn-secondary"
							onClick={handleReset}
						>
							<i className="bi bi-arrow-counterclockwise me-2" />
							Reset
						</button>
					</div>
				</form>
			</div>
		</div>
	);
};

export default SmsOutboundFilters;
